import TagManager from 'react-gtm-module'


export const initTagM = (codeGTag) => {  
    const tagManagerArgs = {
        gtmId: codeGTag
      } 
    TagManager.initialize(tagManagerArgs);
} 

export const eventTagM =  eventCustom => {  

  const dataLayerArgs = { dataLayer: { event: eventCustom } }
  
  TagManager.dataLayer(dataLayerArgs);
} 
  
